import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./basequery";
import { isNull } from "lodash";

export const datasetService = createApi({
  reducerPath: "datasetApi",
  baseQuery: baseQuery,
  tagTypes: ["datasets"],
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  endpoints: (build) => ({
    getDatasets: build.query({
      query: ({ search, ...params }) => {
        let url = !isNull(search)
          ? `/engine/datasets/${search}`
          : `/engine/datasets`;
        return {
          url,
          method: "get",
          params: { ...params },
        };
      },
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.results?.map?.(({ id }) => ({ type: "datasets", id })),
              { type: "datasets", id: "LIST" },
            ]
          : [{ type: "datasets", id: "LIST" }],
    }),
    getDatasetsList: build.query({
      query: () => ({
        url: `/engine/datasets/list/`,
        method: "get",
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.results?.map?.(({ id }) => ({ type: "datasets", id })),
              { type: "datasets", id: "LIST" },
            ]
          : [{ type: "datasets", id: "LIST" }],
    }),

    getDatasetById: build.query({
      query: ({ id }) => ({
        url: `/engine/datasets/${id}/`,
        method: "get",
      }),
    }),

    createDataset: build.mutation({
      query: ({ ...values }) => ({
        url: `/engine/datasets/`,
        method: "post",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "datasets", id: "LIST" }],
    }),

    createExternalDataset: build.mutation({
      query: ({ ...values }) => ({
        url: `/engine/create-dataset/`,
        method: "post",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "datasets", id: "LIST" }],
    }),

    datasetUpload: build.mutation({
      query: ({ formdata }) => ({
        url: `/engine/upload/`,
        method: "post",
        data: formdata,
      }),
    }),

    UploadChunk: build.mutation({
      query: (formdata) => {
        return {
          url: `/engine/upload-chunk/`,
          method: "post",
          data: formdata,
          header: { "Content-Type": "multipart/form-data" },
        };
      },
    }),

    patchDataset: build.mutation({
      query: ({ datasetId, ...values }) => ({
        url: `/engine/datasets/${datasetId}/`,
        method: "patch",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "datasets", id: "LIST" }],
    }),

    deleteDataset: build.mutation({
      query: ({ id }) => ({
        url: `/engine/datasets/${id}/`,
        method: "delete",
      }),
      invalidatesTags: ["datasets"],
    }),
  }),
});

export const {
  useCreateDatasetMutation,
  useCreateExternalDatasetMutation,
  useGetDatasetByIdQuery,
  useGetDatasetsQuery,
  useDatasetUploadMutation,
  usePatchDatasetMutation,
  useGetDatasetsListQuery,
  useDeleteDatasetMutation,
  useUploadChunkMutation,
} = datasetService;
